export default __webpack_public_path__ + "static/media/litho-demo-lifestyle-blog.e279daf2.jpg";